<template>
  <div class="article-detail">
    <div class="main-wrapper" v-if="dataDone">
      <div class="title">{{articleDetail.title}}</div>
      <div class="sub-info"><span class="type" :class="['type-' + articleDetail.type]">{{articleDetail.type | articleType}}</span></div>
      <div class="article-content" v-html="articleDetail.content"></div>
    </div>
    <div class="about-artciles" v-if="dataDone && articleDetail.correlation_article.length > 0">
      <div class="about-title">相关文章</div>
      <div class="about-list">
        <div class="about-item" v-for="item in articleDetail.correlation_article">
          <router-link class="about-article-title" :class="['type-' + item.type]" :to="{name: 'ArticleDetail', params: {id: item.id}}">{{item.title}}</router-link>
        </div>
      </div>
    </div>
    <div class="bottom-control" v-if="dataDone">
      <!-- 点赞 -->
      <div class="like" :class="{'liked': articleDetail.is_likes == 1}">
        <div class="like-button" @click="like" v-show="articleDetail.is_likes == 0">
          <icon icon-class="like-new"></icon>
          <span>点赞</span>
        </div>
        <div class="like-button liked" v-show="articleDetail.is_likes == 1">
          <icon icon-class="liked-new"></icon>
          <span>点赞</span>
        </div>
      </div>
      <!-- 分享 -->
      <div class="share-box">
        <div class="control-item share" @click="share">
          <icon icon-class="share-new"></icon>
          <div class="control-text">分享</div>
        </div>
      </div>
    </div>
    <share :src="locationHref" :title="articleDetail.title" type="干货" ref="shareComponent" v-if="dataDone"></share>
  </div>
</template>

<style lang="less" scoped>
  .article-detail{
    min-height: 100vh;
    background: #F8F8F8;
    padding-top: 10px;
    .main-wrapper{
      width: 100%;
      padding: 24px 20px;
      background: #FFF;
      .title{
        font-size: 18px;
        line-height: 28px;
        color: #333;
        font-weight: bold;
      }
      .sub-info{
        margin-top: 8px;
        display: flex;
        align-items: center;
        font-size: 13px;
        line-height: 13px;
        color: #666;
        .type{
          position: relative;
          padding-left: 17px;
          font-size: 13px;
          line-height: 13px;
          color: #666;
          margin-right: 8px;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: #CCC;
            z-index: 2;
          }
          &::before{
            content: '';
            position: absolute;
            left: 4px;
            top: 4px;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #FFF;
            opacity: .6;
            z-index: 3;
          }
          &.type-1::after{
            background: #53BE19;
          }
          &.type-2::after{
            background: #6C4BC9;
          }
          &.type-4::after{
            background: #DC42E2;
          }
          &.type-5::after{
            background: #F64865;
          }
          &.type-6::after{
            background: #FAA12D;
          }
          &.type-7::after{
            background: #25C0C2;
          }
          &.type-8::after{
            background: #FFA2DA;
          }
          &.type-9::after{
            background: #0091FF;
          }
        }
      }
      .article-content{
        margin-top: 16px;
        padding-top: 24px;
        border-top: 1px solid #DDD;
        font-size: 14px;
        line-height: 24px;
        color: #333;
        ul{
          padding-left: 12px;
          li{
            list-style: inherit;
            ul{
              list-style: circle;
              ul{
                list-style: square;
              }
            }
          }
        }
      }
    }
    .about-artciles{
      margin-top: 10px;
      width: 100%;
      padding: 14px 20px 20px;
      background: #FFF;
      .about-title{
        font-size: 18px;
        line-height: 28px;
        color: #333;
        font-weight: bold;
      }
      .about-list{
        .about-item{
          padding: 12px 0;
          border-bottom: 1px solid #DDD;
          font-size: 14px;
          line-height: 20px;
          color: #333;
          &:last-child{
            border-bottom: 0;
          }
          .about-article-title{
            position: relative;
            padding-left: 12px;
            color: #333;
            display: block;
            &::after{
              content: '';
              position: absolute;
              top: 8px;
              left: 0;
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background: #CCC;
            }
            &.type-1::after{
              background: #53BE19;
            }
            &.type-2::after{
              background: #6C4BC9;
            }
            &.type-4::after{
              background: #DC42E2;
            }
            &.type-5::after{
              background: #F64865;
            }
            &.type-6::after{
              background: #FAA12D;
            }
            &.type-7::after{
              background: #25C0C2;
            }
            &.type-8::after{
              background: #FFA2DA;
            }
            &.type-9::after{
              background: #0091FF;
            }
          }
        }
      }
    }
    /* 小组课底部操作 */
    .bottom-control{
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 58px;
      border-top: 1px solid #BDBDBD;
      background-color: #fff;
      z-index: 990;
      &.iphonex{
        height: 67px;
      }
      .share-box{
        position: relative;
        padding: 0 44px;
        &::after{
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 38px;
          background: #EEE;
        }
        .share{
          width: 1.73rem;
          height: 38px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFF;
          background: @cano;
          border-radius: 21px;
          font-size: 14px;
          .control-text{
            position: relative;
            top: 1px;
          }
          svg{
            font-size: 18px;
            margin-right: 8px;
          }
        }
      }
      .like{
        padding: 0 44px;
        .like-button{
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          font-size: 14px;
          span{
            position: relative;
            top: 1px;
            margin-left: 8px;
          }
        }
        svg{
          font-size: 18px;
          color: #333;
        }
        &.liked svg,
        &.liked span{
          color: @cano;
        }
      }
      // .control-item{
      //   position: relative;
      //   box-sizing: border-box;
      //   // flex: 1;
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      //   height: 48px;
      //   background-color: transparent;
      //   border: 0;
      //   color: #333;
      //   padding: 0 36px;
      //   &::after{
      //     content: '';
      //     position: absolute;
      //     top: 50%;
      //     right: 0;
      //     width: 1px;
      //     height: 18px;
      //     background: #F6F7F8;
      //     transform: translateY(-50%);
      //   }
      //   &:first-child{
      //     color: @cano;
      //   }
      //   .control-text{
      //     font-size: 12px;
      //     margin-left: 8px;
      //   }
      // }
    }
  }
</style>

<script>
  import share from '@/components/Common/share.vue'
  export default {
    data() {
      return {
        dataDone: false,
        articleDetail: null,
        locationHref: '',
      }
    },
    watch: {
      '$route'() {
        // 跳转其他课程详情时重新获取数据
        this.id = this.$route.params.id;
        this.locationHref = window.location.href;
        this.getData();
        $(document).scrollTop(0);
      }
    },
    components: {
      share
    },
    created() {
      this.locationHref = window.location.href;
      this.getData();
    },
    methods: {
      getData() {
        this.$root.post('/Article/get_article_detail', {
          id: this.$route.params.id
        }).then(data => {
          this.dataDone = true;
          data.content = data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
          this.articleDetail = data;
          this.articleDetail.correlation_article = data.correlation_article || [];
        })
      },
      // 点赞文章
      like() {
        this.$root.post('/Article/click_likes', {
          id: this.$route.params.id
        }).then(data => {
          this.articleDetail.is_likes = 1;
          this.articleDetail.likes = parseInt(this.articleDetail.likes) + 1;
        })
      },
      share() {
        this.$refs.shareComponent.showMenu();
      }
    },
    filters: {
      articleType(value) {
        switch(parseInt(value)) {
          case 1: return '在路上';break;
          case 2: return '经验弹';break;
          case 3: return '设计说';break;
          case 4: return '话局';break;
          case 5: return '设计室';break;
          case 6: return '资讯';break;
          case 7: return '名校记';break;
          case 8: return '奇想集';break;
          case 9: return '交互设计';break;
        }
      },
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY/MM/DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Articles/detail.vue